<template>
    <v-dialog persistent v-model="showRelationFromStatus" max-width="480">
        <v-card>
            <validation-observer v-slot="{ handleSubmit }">
                <v-card-text class="d-flex align-center justify-space-between">
                    Chuyển mối quan hệ
                    <v-btn color="default" class="ma-0" small icon @click="closeRelation()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-text>
                <div style="padding: 0px 10px;">
                    <validation-provider
                            v-slot="{ errors }"
                            class="mb-2"
                            rules="required"
                            name="Chuyển mối quan hệ"
                    >
                        <v-autocomplete
                                v-model="statusId"
                                :items="contactStatusList"
                                item-text="name"
                                item-value="id"
                                label
                                :error-messages="errors"
                        />
                    </validation-provider>
                </div>

                <v-card-actions class="d-flex justify-center mt-3">
                    <v-btn
                            color="success"
                            small
                            @click.prevent="handleSubmit(changeSelectStatus)"
                    >Đồng ý</v-btn>

                </v-card-actions>
            </validation-observer>
        </v-card>
    </v-dialog>
</template>
<script>
    import RepositoryFactory from '../../../repositories/RepositoryFactory';
    const ContactRepository = RepositoryFactory.get('contact');
    const ContactStatusRepository = RepositoryFactory.get('contact_status');
    const AppointmentRepository = RepositoryFactory.get('appointment')

    export default {
        data() {
            return {
                showRelationFromStatus: false,
                statusId: '',
                contactStatusList: [],
                dataContact: {},
            };
        },
        async created() {
            Bus.$on('show-relation-from-convert-status', (appointment, statusAppointment) => {
                this.dataAppointment = appointment
                this.dataContact = _.get(this.dataAppointment, 'customer.contact', {}) || {}
                this.appointmentId = appointment.id
                this.statusAppointment = statusAppointment
                this.getContactStatusList()
                this.showRelationFromStatus = true
            })
            Bus.$on('cancel-sub-contact-appointment', (appointment, statusAppointment) => {
                this.dataAppointment = appointment
                this.dataContact = _.get(this.dataAppointment, 'customer.contact', {}) || {}
                this.appointmentId = appointment.id
                this.statusAppointment = statusAppointment
                this.statusId = appointment.customer.contact.contactStatus.id
                this.changeSelectStatus()
            })
        },
        destroyed() {
            Bus.$off('hide-button-finish')
            Bus.$off('show-relation-from-convert-status')
        },
        methods: {
            closeRelation() {
                this.showRelationFromStatus = false;
                this.statusId = '';
            },
            async getContactStatusList() {
                // const loading = this.$loading.show();
                this.appLoadingData(true)
                let store = 'T';
                let selectType = ['T1', 'T2', 'T3'];
                if (_.get(this.dataContact, 'contactStatus.type', 'T').includes('C')) {
                    store = 'C';
                    selectType = ['C1', 'C2', 'C3'];
                }
                if (_.get(this.dataContact, 'contactStatus.type', 'T').includes('G')) {
                    store = 'G';
                    selectType = ['G1', 'G2', 'G3'];
                }
                if (_.get(this.dataContact, 'contactStatus.type', 'T').includes('M')) {
                    store = 'M';
                    selectType = ['M1', 'M2', 'M3'];
                }
                const response = await ContactStatusRepository.list({store});
                // loading.hide();
                this.appLoadingData(false)
                if (response.success) {
                    const contactStatusList = [];
                    const tempList = [];
                    _.get(response, 'data', []).forEach(contactStatus => {
                        _.get(contactStatus, 'data', []).forEach(data => {
                            tempList.push({
                                type: contactStatus.type,
                                id: _.get(data, 'id', 0),
                                name: _.get(data, 'name', 0),
                            });
                        });
                    });
                    const checkType = {};
                    tempList.forEach(contactStatus => {
                        const typeContactStatus = contactStatus.type;
                        if (selectType.includes(typeContactStatus)) {
                            if (!checkType[typeContactStatus]) {
                                checkType[typeContactStatus] = true;
                                if (contactStatusList.length > 0) {
                                    contactStatusList.push({ divider: true });
                                }
                                contactStatusList.push({
                                    header: typeContactStatus,
                                    style: 'color: red;'
                                });
                            }
                            contactStatusList.push(contactStatus);
                        }
                    });
                    for (let i = 0; i < contactStatusList.length; i++) {
                        if (contactStatusList[i].header === 'T0' || contactStatusList[i].type === 'T0' 
                            || contactStatusList[i].header === 'C0' || contactStatusList[i].type === 'C0'
                            || contactStatusList[i].header === 'G0' || contactStatusList[i].type === 'G0') {
                            contactStatusList.splice(i, 1)
                        }
                    }
                    this.contactStatusList = contactStatusList;
                    console.log(contactStatusList)
                } else {
                    this.contactStatusList = [];
                }
            },
            async changeSelectStatus() {
                const dataUpdate = [
                    {
                        contactId: this.dataContact.id,
                        statusId: this.statusId
                    }
                ];
                // const loading = this.$loading.show();
                this.appLoadingData(true)
                const response = await ContactRepository.updateContactStatus(dataUpdate);
                // loading.hide();
                this.appLoadingData(false)
                if (response.error) {
                    this.$swal({
                        type: 'error',
                        title: 'Lỗi !',
                        text: _.get(response, 'message', ''),
                    }).then(() => {
                        this.showRelationFromStatus = false
                    });
                } else {
                    this.showRelationFromStatus = false;
                    // const loader = this.$loading.show()
                    this.appLoadingData(true)
                    const response = await AppointmentRepository.updateStatus(this.appointmentId, this.statusAppointment)
                    // loader.hide()
                    this.appLoadingData(false)
                    if(response.error){
                        this.$swal({
                            type: 'error',
                            title: 'Lỗi !',
                            text: _.get(response, 'message', ''),
                        })
                    }else {
                        Bus.$emit('appointment-list-reload')
                        Bus.$emit('reset-fech-notifications')
                    }
                }
                this.statusId = null
            },
        }
    };
</script>
